module.exports = {
          srcSet: __webpack_public_path__ + "252d8fdd7dd5c8d0cb4da5a42565eb21-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "252d8fdd7dd5c8d0cb4da5a42565eb21-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "252d8fdd7dd5c8d0cb4da5a42565eb21-60.png",
          toString:function(){return __webpack_public_path__ + "252d8fdd7dd5c8d0cb4da5a42565eb21-60.png"},
          
          width: 60,
          height: 60
        }